/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';

export class AtlasOrganization {
  /**
  * Eon-assigned account ID.
  */
  'id': string;
  /**
  * The organization display name in Eon.
  */
  'name': string;
  /**
  * MongoDB Atlas Organization ID.
  */
  'atlasOrganizationId': string;
  'state': AccountState;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "atlasOrganizationId",
      "baseName": "atlasOrganizationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "state",
      "baseName": "state",
      "type": "AccountState",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AtlasOrganization.attributeTypeMap;
  }

  public constructor() {
  }
}



